import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import "./skeleton.css";
import ScrollToTop from "./ScrollToTop";

export default function Blog() {
  const { slug } = useParams();

  const [getData, setgetData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`https://tamizhtechie-test.herokuapp.com/blog/${slug}`)
      .then((res) => {
        setgetData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const newpara = getData.description;

  return (
    <div>
      <div>
        {/* <Helmet>
          <link rel="canonical" href={window.location.href} />
          <title>{getData.title}</title>
          <meta property="description" content={getData.para1} />
          <meta name="keywords" content={getData.keywords} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="" />
          <meta property="og:title" content={getData.title} />
          <meta property="og:description" content={getData.title} />
          <meta property="og:image" content={getData.imageUrl} />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta
            property="fb:app_id"
            content="https://www.facebook.com/tamizhtechie123"
          />
          <meta name="twitter:site" content="@website-username"></meta>

          <meta name="twitter:title" content={getData.title} />
          <meta name="twitter:description" content={getData.title} />
          <meta name="twitter:image" content={getData.imageUrl} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet> */}
        <ScrollToTop />
        <div className="read">
          <div className="container">
            {isLoading ? (
              <div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-12 col-md-8">
                      <div class="ssc-head-line" style={{ height: 45 }}></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-2">
                      <div class="ssc-head-line mt-4"></div>
                    </div>
                    <div class="col-3 col-md-1"></div>
                    <div class="col-3 col-md-2">
                      <div class="ssc-head-line mt-4"></div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-12 col-md-8">
                      <div class="ssc-square" style={{ height: 500 }}></div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-12 col-md-8">
                      <div class="ssc-square" style={{ height: 40 }}></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="col-md-10">
                    <h1>{getData.title}</h1>
                    <div className="row mt-4">
                      <div className="col-4">
                        <h4>{getData.category}</h4>
                      </div>
                      <div className="col-4">
                        <h2>
                          <i class="fa fa-user pr-2" aria-hidden="true"></i>
                          <a
                            target="_blank"
                            className="readauthor"
                            href={
                              getData.author === "Balaji"
                                ? "https://www.linkedin.com/in/babzbalaji/"
                                : "Rakshana"
                            }
                          >
                            {getData.author}
                          </a>
                        </h2>
                      </div>
                      <div className="col-6 col-md-4">
                        <h6>
                          {" "}
                          <i
                            className="fa fa-calendar pr-3"
                            aria-hidden="true"
                          ></i>
                          {getData.date}
                        </h6>
                      </div>
                      <div className="col-3"></div>
                    </div>
                    <img
                      // alt={newdata.imgalt}
                      src={getData.imageUrl}
                      className="img-fluid read-img"
                    ></img>

                    {/* {newdata.imagecredits ? (
                    <div>
                      Image Credits :{" "}
                      <a target="_blank" href={newdata.imagecredits}>
                        {newdata.imagecreditname}
                      </a>
                    </div>
                  ) : (
                    <div></div>
                  )} */}

                    <div
                      className="newsbody"
                      dangerouslySetInnerHTML={{ __html: newpara }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
